export default {"src":"/pro/_next/static/media/ink.020a0070.svg","height":111,"width":111,"blurWidth":0,"blurHeight":0};